export default __webpack_public_path__ + "static/chichik-664ea2844ba3ddde6d3424c94d947ee0.png";